"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var field_picker_direction_1 = require("./model/field-picker-direction");
var Observable_1 = require("rxjs/Observable");
require("rxjs/add/observable/zip");
function convertFieldViewsToFieldPath(fields) {
    if (fields.length === 0) {
        return '';
    }
    var path = '';
    fields.forEach(function (rec, index) {
        if (index !== 0 && rec.selectedField) {
            path += rec.selectedField.value + ',';
        }
    });
    return path.substring(0, path.length - 1);
}
exports.convertFieldViewsToFieldPath = convertFieldViewsToFieldPath;
function convertFieldViewsToFieldPathDisplayName(fields) {
    if (!fields || fields.length === 0) {
        return '';
    }
    var fieldPathView = fields[0].selectedField.name;
    fields.forEach(function (field, index) {
        if (index > 0) {
            if (field.selectedField.value && field.selectedField.value.substring(0, 1) === '<') {
                fieldPathView += ' « ' + field.selectedField.name;
            }
            else {
                fieldPathView += ' » ' + field.selectedField.name;
            }
        }
    });
    return fieldPathView;
}
exports.convertFieldViewsToFieldPathDisplayName = convertFieldViewsToFieldPathDisplayName;
function convertFieldPathToFieldViews(fieldPath, fieldsPathService, firstFieldOptions) {
    if (firstFieldOptions === void 0) { firstFieldOptions = []; }
    var fieldExpressionArray = fieldPath.split(',');
    return Observable_1.Observable.zip(generateFirstFieldView(fieldExpressionArray[0], fieldsPathService, firstFieldOptions), fieldsPathService.getFields(fieldExpressionArray))
        .switchMap(function (_a) {
        var firstField = _a[0], fields = _a[1];
        var result = [firstField];
        for (var _i = 0, fieldExpressionArray_1 = fieldExpressionArray; _i < fieldExpressionArray_1.length; _i++) {
            var fieldExpression = fieldExpressionArray_1[_i];
            if (fieldExpression.startsWith('<')) {
                result[result.length - 1].direction = field_picker_direction_1.FieldPickerDirection.INCOMING;
            }
            var field = fields[fieldExpression][0];
            result.push({
                selectedField: field,
                direction: field_picker_direction_1.FieldPickerDirection.OUTGOING
            });
        }
        return Observable_1.Observable.of(result);
    });
}
exports.convertFieldPathToFieldViews = convertFieldPathToFieldViews;
function generateFirstFieldView(fieldExpression, fieldsPathService, firstFieldOptions) {
    return getFirstField(fieldExpression, fieldsPathService).switchMap(function (firstField) {
        var options = [firstField];
        if (firstFieldOptions && firstFieldOptions.length) {
            // selected field should be the same object in the options
            options.push.apply(options, firstFieldOptions.filter(function (option) { return option.name !== firstField.name; }));
        }
        return Observable_1.Observable.of({
            selectedField: firstField,
            direction: field_picker_direction_1.FieldPickerDirection.OUTGOING,
            options: options
        });
    });
}
function getFirstField(fieldExpression, fieldsPathService) {
    if (fieldExpression.startsWith('<')) {
        return getFirstFieldIncoming(fieldExpression, fieldsPathService);
    }
    return getFirstFieldOutgoing(fieldExpression);
}
function getFirstFieldIncoming(fieldExpression, fieldsPathService) {
    // example: <Activity.PROJECT>, we will need to get the field for Activity.PROJECT to get the field of Project as it is the origin
    var fieldExpressionWithoutBrackets = fieldExpression.replace(/[\\<\\>]/g, '');
    return fieldsPathService.getFields([fieldExpressionWithoutBrackets])
        .map(function (result) {
        var field = result[fieldExpressionWithoutBrackets][0];
        return {
            name: field.name,
            value: '',
            targetCategory: field.targetCategory
        };
    });
}
function getFirstFieldOutgoing(fieldExpression) {
    // example: Project.projectWfStateId, parent will be Project
    var parent = fieldExpression.split('.')[0];
    return Observable_1.Observable.of({
        name: parent,
        value: '',
        targetCategory: parent
    });
}
//# sourceMappingURL=path-converters.js.map